import customDataTableStyle from 'assets/styles/customDataTableStyle';
import { thunkTaxCodeInfo } from 'features/Tools/toolSlice';
import KTFormTextArea from 'general/components/OtherKeenComponents/Forms/KTFormTextArea';
import KTBSDropdown, {
  KTBSDropdownAlignments,
} from 'general/components/OtherKeenComponents/KTBSDropdown';
import VIButton from 'general/components/VietInvoice/VIButton';
import VIDataTable from 'general/components/VietInvoice/VIDataTable';
import ToastHelper from 'general/helpers/ToastHelper';
import Global from 'general/utils/Global';
import Utils from 'general/utils/Utils';
import _ from 'lodash';
import { useEffect, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { ClockLoader } from 'react-spinners';
import PropTypes from 'prop-types';

TaxCodeInfoScreen.propTypes = {
  navItemList: PropTypes.array,
};

TaxCodeInfoScreen.defaultProps = {
  navItemList: [],
};

/**
 *
 * @param {{
 *  navItemList: object[],
 * }} props
 * @returns
 */
function TaxCodeInfoScreen(props) {
  // ---- params ----
  const { navItemList } = props;
  const { t } = useTranslation();
  const columns = useMemo(() => {
    return [
      {
        name: t('TaxCode'),
        sortable: false,
        width: '120px',
        cell: (row) => {
          return (
            <p data-tag="allowRowEvents" className="text-dark-75 font-weight-bold m-0">
              {row?.taxCode}
            </p>
          );
        },
      },
      {
        name: t('UnitName'),
        sortable: false,
        minWidth: '220px',
        cell: (row) => {
          return (
            <p data-tag="allowRowEvents" className="text-dark-75 m-0">
              {row?.companyName}
            </p>
          );
        },
      },
      {
        name: t('Address'),
        sortable: false,
        minWidth: '260px',
        cell: (row) => {
          return (
            <p data-tag="allowRowEvents" className="text-dark-75 m-0">
              {row?.address}
            </p>
          );
        },
      },
      {
        name: t('Status'),
        sortable: false,
        minWidth: '220px',
        cell: (row) => {
          return (
            <p data-tag="allowRowEvents" className="text-dark-75 m-0">
              {row?.status}
            </p>
          );
        },
      },
      {
        name: t('DocumentRelated'),
        sortable: false,
        minWidth: '180px',
        cell: (row) => {
          return <p data-tag="allowRowEvents" className="text-dark-75 m-0"></p>;
        },
      },
    ];
  }, [t]);
  const dispatch = useDispatch();
  const [textTaxCodes, setTextTaxCodes] = useState(Global.gFilterTaxCodeInfo.q);
  const { taxCodeInfoItems, isGettingTaxCodeInfo } = useSelector((state) => state.tool);
  const [queries, setQueries] = useState([]);
  const [exporting, setExporting] = useState(false);
  const dropdownMenuItems = useMemo(() => {
    return navItemList.map((item) => {
      return {
        name: item.text,
        value: item.text,
        icon: item.icon,
        onPress: item.onPress,
      };
    });
  }, [navItemList]);

  useEffect(() => {
    const breakpoint = /[,.\s]/;
    const arrTaxCodes = _.filter(
      textTaxCodes.split(breakpoint),
      (item) => !_.isEmpty(item.trim())
    )?.map((item) => item?.trim());
    setQueries(arrTaxCodes);
  }, [textTaxCodes]);

  // ---- methods -----
  async function findCompaniesByQueries() {
    if (queries.length > 20) {
      ToastHelper.showError('Bạn vui lòng chỉ nhập tối đa 20 mã');
      return;
    }
    dispatch(thunkTaxCodeInfo(JSON.stringify(queries)));
  }

  async function handleExport() {
    if (taxCodeInfoItems?.length === 0) {
      return;
    }
    setExporting(true);
    const dataToExport = taxCodeInfoItems.map((row) => {
      return {
        [t('TaxCode')]: row?.taxCode,
        [t('UnitName')]: row?.companyName,
        [t('Address')]: row?.address,
        [t('Status')]: row?.status,
        [t('DocumentRelated')]: '',
      };
    });
    Utils.exportToCSV(dataToExport, 'tax_code_info');
    setExporting(false);
  }

  return (
    <div className="h-100">
      <VIDataTable
        draggable={false}
        tableStyles={customDataTableStyle}
        title={
          <div className="d-flex align-items-center justify-content-center gap-1">
            <div className="d-block d-lg-none">
              <KTBSDropdown
                toggleElement={
                  <div className="w-30px h-30px button-close cursor-pointer d-flex align-items-center justify-content-center bg-transparent">
                    <i className="fa-solid fa-bars text-grey" />
                  </div>
                }
                alignment={KTBSDropdownAlignments.start}
                dropdownMenuItems={dropdownMenuItems}
                selectedValue={t('LookUpActiveStateTaxCode')}
                onChange={(newValue) => {}}
              />
            </div>{' '}
            {t('LookUpActiveStateTaxCode')}
          </div>
        }
        selectable={false}
        pagination={null}
        onChangePage={(page) => {
          let iNewPage = parseInt(page);
          iNewPage -= 1;
          if (iNewPage < 0) {
            iNewPage = 0;
          }
        }}
        onChangeRowsPerPage={(perPage) => {}}
        fullColumns={columns}
        data={taxCodeInfoItems}
        loading={false}
        filterbar={
          <>
            <KTFormTextArea
              name="textAreaMST"
              text="Nhập tối đa 20 mã, mỗi mã phân cách nhau bởi dấu phẩy hoặc mỗi mã 1 dòng"
              placeholder="Nhập mã số thuế..."
              value={textTaxCodes}
              onChange={(value) => {
                Global.gFilterTaxCodeInfo.q = value;
                setTextTaxCodes(value);
              }}
            />
          </>
        }
        onRowClick={(row) => {}}
        onSetSelectedMultiItems={(rows) => {}}
        toolbar={
          <>
            <VIButton
              beforeIcon={
                isGettingTaxCodeInfo ? (
                  <ClockLoader color="white" size={20} />
                ) : (
                  <i className="fa-regular fa-search" />
                )
              }
              text={isGettingTaxCodeInfo ? `${t('LookingUp')}...` : t('LookUp')}
              className="btn-blue border-0 p-3"
              onClick={() => {
                findCompaniesByQueries(queries);
              }}
              disabled={isGettingTaxCodeInfo}
            />

            <VIButton
              beforeIcon={<i className="fa-regular fa-download" />}
              text={t('Download')}
              className="btn-blue border-0 p-3"
              onClick={handleExport}
            />
          </>
        }
      />
    </div>
  );
}

export default TaxCodeInfoScreen;
